import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-actualizacion-exitosa',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {




  constructor(private router: Router) {

    

    /*
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {   
        console.log('SuccessComponent NavigationStart ', event);
      };
    });
    
   
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {   
        console.log('SuccessComponent NavigationEnd ', event);
      };
    });
    */

    

  }

  ngOnInit(): void {

  }



}